/** Helpers for guest chat session-transfer / reclaim system messages. */

import { isSystemMessage } from "./verificationMessages";

export const isSessionTransferredMessage = (msg) =>
  isSystemMessage(msg) &&
  /session transferred to new device/i.test(String(msg?.text || ""));

export const isSessionClaimedMessage = (msg) =>
  isSystemMessage(msg) &&
  /claimed by another device/i.test(String(msg?.text || ""));

const messageTime = (msg) => {
  const raw = msg?.createdAt || msg?.created_at || msg?.timestamp;
  if (!raw) return 0;
  const time = new Date(raw).getTime();
  return Number.isFinite(time) ? time : 0;
};

/**
 * Latest session-transfer status for the sticky chat banner.
 * Prefers the most recent session-transfer-related system message.
 * Messages at/before reclaimedAt are ignored after a successful reclaim.
 */
export const getSessionTransferBannerState = (messages = [], reclaimedAt = 0) => {
  const cutoff = Number(reclaimedAt) || 0;

  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const msg = messages[i];
    if (cutoff && messageTime(msg) <= cutoff) continue;

    if (isSessionClaimedMessage(msg)) {
      return { type: "claimed" };
    }
    if (isSessionTransferredMessage(msg)) {
      return { type: "transferred" };
    }
  }

  return null;
};
